<template>
  <b-row
    v-if="model"
    :id="formId"
    class="d-flex flex-wrap justify-content-around align-items-center iq-card-body "
  >
    <b-col v-for="(field, i) in Fields" :key="i" :xl="field.xl">
      <template v-if="field.type === 'spacer'">
        <hr v-if="field.line" />
        <div class="fw-bold h5 text-grey" v-if="field.label">
          {{ field.label }}
        </div>
      </template>
      <!-- start normalTypes -->
      <div v-if="normalTypes.includes(field.type)">
        <ValidationProvider
          :name="field.name"
          :rules="field.rules"
          v-slot="{ passed, failed, failedRules, errors }"
        >
          <!-- start textarea type -->
          <b-form-group
            v-if="field.type === 'textarea'"
            label="Example textarea"
            :label-for="generateFieldId(field.name, i)"
          >
            <b-form-textarea
              :id="generateFieldId(field.name, i)"
              :rows="field.rows"
              :placeholder="field.placeholder"
              v-model="field.value"
              :class="{
                'is-invalid': errors.length > 0,
                'border-success': passed
              }"
            ></b-form-textarea>
            <!-- show error message -->
            <div v-if="errors.length" class="invalid-feedback">
              {{
                failed && field.validationMessage
                  ? field.validationMessage[Object.keys(failedRules)[0]]
                  : errors[0]
              }}
            </div>
          </b-form-group>
          <!-- end textarea type -->

          <b-form-group
            v-else-if="field.type === 'number'"
            :label="field.label"
            :label-for="generateFieldId(field.name, i)"
          >
            <b-form-input
              :min="field.min"
              :max="field.max"
              :id="generateFieldId(field.name, i)"
              :class="{
                'is-invalid': errors.length > 0,
                'border-success': passed
              }"
              :type="field.type"
              :placeholder="field.placeholder"
              v-model="model[field.name]"
              @input="validateNumber(field.name, field.min, field.max)"
            ></b-form-input>

            <!-- show error message -->
            <div v-if="errors.length" class="invalid-feedback">
              {{
                failed && field.validationMessage
                  ? field.validationMessage[Object.keys(failedRules)[0]]
                  : errors[0]
              }}
            </div>
          </b-form-group>

          <b-form-group v-else :label="field.label">
            <b-form-input
              :id="generateFieldId(field.name, i)"
              :class="{
                'is-invalid': errors.length > 0,
                'border-success': passed
              }"
              :type="field.type"
              :placeholder="field.placeholder"
              v-model="model[field.name]"
            ></b-form-input>

            <div v-if="errors.length" class="invalid-feedback">
              {{
                failed && field.validationMessage
                  ? field.validationMessage[Object.keys(failedRules)[0]]
                  : errors[0]
              }}
            </div>
          </b-form-group>
        </ValidationProvider>
      </div>

      <LocalizedComponent
        v-else-if="field.type === 'localized'"
        :field="field"
        :localeValues="model[field.name]"
        :isInList="isInList"
      ></LocalizedComponent>

      <!-- end normalTypes -->
      <div v-else-if="customTypes.includes(field.type)">
        <!-- start if select type  -->
        <div v-if="field.type === 'select'">
          <ValidationProvider
            :name="field.name"
            :rules="field.rules"
            v-slot="{ passed, failed, failedRules, errors }"
          >
            <b-form-group :label="field.label">
              <b-form-select
                plain
                :id="generateFieldId(field.name, i)"
                v-model="model[field.name]"
                :class="{
                  'is-invalid': errors.length > 0,
                  'border-success': passed
                }"
              >
                <b-form-select-option
                  v-for="type in field.options"
                  :value="type.value"
                  :key="type.value"
                  >{{ type.label }}
                </b-form-select-option>
              </b-form-select>

              <div v-if="errors.length" class="invalid-feedback">
                {{
                  failed && field.validationMessage
                    ? field.validationMessage[Object.keys(failedRules)[0]]
                    : errors[0]
                }}
              </div>
            </b-form-group>
          </ValidationProvider>
        </div>
        <!-- end if select type  -->

        <div v-else>
          <ValidationProvider
            :name="field.name"
            :rules="field.rules"
            v-slot="{ passed, failed, failedRules, errors }"
          >
            <b-form-checkbox
              v-model="model[field.name]"
              v-if="field.type === 'checkbox'"
              :disabled="field.disabled"
              @change="handleAction({ action: field.change, model: model })"
              :value="true"
              :unchecked-value="false"
              >{{ field.label }}</b-form-checkbox
            >
            <b-form-group
              v-else
              :label="field.label"
              :label-for="generateFieldId(field.name, i)"
            >
              <date-picker
                v-if="field.type === 'date-range'"
                v-model="model[field.name]"
                :id="generateFieldId(field.name, i)"
                range
                :class="{
                  'is-invalid': errors.length > 0,
                  'border-success': passed
                }"
              >
              </date-picker>
              <!-- CheckBox-->
              <flat-pickr v-else-if="field.type === 'date'"  :config="{ dateFormat: 'Y-m-d' }"
                  class="form-control" 
                  v-model="model[field.name]" 
                  placeholder="Select Date" 
                  :class="{
                  'is-invalid': errors.length > 0,
                  'border-success': passed
                   }"></flat-pickr>
              <b-form-input
                v-else
                :id="generateFieldId(field.name, i)"
                :type="field.type"
                v-model="model[field.name]"
                :class="{
                  'is-invalid': errors.length > 0,
                  'border-success': passed
                }"
              >
              </b-form-input>
              <!-- show error message -->
              <div v-if="errors.length" class="invalid-feedback">
                {{
                  failed && field.validationMessage
                    ? field.validationMessage[Object.keys(failedRules)[0]]
                    : errors[0]
                }}
              </div>
            </b-form-group>
          </ValidationProvider>
        </div>
      </div>
      <!-- start customValidationTypes -->
      <div v-else-if="customValidationTypes.includes(field.type)">
        <ValidationProvider
          :name="field.validationModel"
          :rules="field.rules"
          v-slot="{ passed, failed, failedRules, errors }"
        >
          <!-- start phone type -->
          <div v-if="field.type === 'phone'">
            <b-form-group
              :label="field.label"
              :label-for="generateFieldId(field.name, i)"
            >
              <phone-number
                v-model="model[field.name]"
                :rules="field.rules"
                :field="field"
                :errors.sync="phone_value_change"
                :class="{
                  'is-invalid': errors.length > 0,
                  'border-success': passed
                }"
              />
              <p v-if="phone_value_change" class="text-danger">
                {{ phone_value_change }}
              </p>
              <div v-if="errors.length" class="invalid-feedback">
                {{
                  failed && field.validationMessage
                    ? field.validationMessage[Object.keys(failedRules)[0]]
                    : errors[0]
                }}
              </div>
            </b-form-group>
          </div>
          <!-- end phone type -->
          <div v-else-if="field.type === 'file'">
            <!-- {{ model[field.name] && model[field.name].length > 0 }} -->
            <b-form-group :label="field.label">
              <div >
                <FileUpload
                  :field="field"
                  v-model="model[field.name]"
                  :multiple="field.multiple"
                  @updated="$emit('updated')"
                />
              </div>
            </b-form-group>
          </div>
          <div v-else-if="field.type === 'userPhoto'">
            <!-- {{ model[field.name] && model[field.name].length > 0 }} -->
            <b-form-group :label="field.label">
              <div v-if="model[field.name] && model[field.name].length == 0">
                <FileUpload
                  v-if="isShowUploadComponent === false"
                  :field="field"
                  v-model="model[field.name]"
                  :multiple="field.multiple"
                  @updated="$emit('updated')"
                />

                <div v-else class="d-flex flex-column align-items-center">
                  <!-- عرض الصورة إذا كانت موجودة -->
                  <b-img
                    v-if="model[field.value]"
                    class="profile-pic height-150 width-150 mb-2"
                    fluid
                    :src="model[field.value]"
                    alt="profile-pic"
                  />

                  <!-- زر رفع الصورة -->
                  <b-button
                    @click="showUploadComponent"
                    variant="primary"
                    size="sm"
                  >
                    <i class="ri-upload-2-line"></i> Upload Image
                  </b-button>
                </div>
              </div>
              <FileUpload
                v-else
                :field="field"
                v-model="model[field.name]"
                :multiple="field.multiple"
                @updated="$emit('updated')"
              />
            </b-form-group>
          </div>
          <div v-else-if="field.type === 'custom-file-upload'">
            <CustomFileUpload
              :field="field"
              v-model="model[field.name]"
              :def="model[field.value]"
            />
          </div>
        </ValidationProvider>
      </div>
      <!-- end customValidationTypes -->
    </b-col>
  </b-row>
</template>
<script>
import PhoneNumber from "@/components/PhoneNumber.vue";
import LocalizedComponent from "../LocalizedComponent.vue";
import FileUpload from "../FileUpload.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import CustomFileUpload from "../CustomFileUpload.vue";
export default {
  name: "FormGenerator",
  components: {
    PhoneNumber,
    LocalizedComponent,
    FileUpload,
    DatePicker,
    CustomFileUpload
  },
  props: {
    Fields: Array,
    isInList: Boolean,
    model: Object,
    globalClass: String,
    id: String,
    index: Number,
    modelPath: String
  },
  data() {
    return {
      isShowUploadComponent: true,
      phone_value_change: "",
      normalTypes: [
        "text",
        "email",
        "number",
        "number-native",
        "textarea",
        "label",
        "password",
        "validation",
        "",
        null
      ],
      customTypes: [
        "select",
        "color",
        "color-options",
        "date",
        "month",
        "week",
        "time",
        "datetime-local",
        "date-range",
        "checkbox",
        "select2",
        "periods-pricing",
        "pricing",
        "location"
      ],
      customValidationTypes: [
        "file",
        "userPhoto",
        "phone",
        "payments",
        "location",
        "custom-file-upload",
        "checkbox-list"
      ]
    };
  },
  computed: {
    // Generates for normal and nested
    // Ex form , form-1 , form-form-0 , form-form-0-form-0 , ....
    formId() {
      return this.id ? this.id : "form";
    },
    formModelPath() {
      return this.modelPath ? this.modelPath : "";
    }
  },
  methods: {
    showUploadComponent() {
      this.isShowUploadComponent = false;
    },
    generateFieldId(fieldName, index) {
      return `${this.formId}-${fieldName}-${index}`;
    },
    validateNumber(fieldName, min, max) {
      if (this.model[fieldName] < min) {
        this.model[fieldName] = min;
      } else if (this.model[fieldName] > max) {
        this.model[fieldName] = max;
      }
    },
    // addSubFor(props) {
    //   this.$emit('addSubFor', props)
    // },
    // removeSubFrom(props) {
    //   this.$emit('removeSubFrom', props)
    // },
    handleAction(props) {
      if (props.action) this.$emit("handleAction", props);
    }
  }
};
</script>
